<template>
    <v-card v-bind="$attrs">
      <v-card-title @click="toggle"><v-icon left :color="colorC">{{iconC}}</v-icon> <span>{{titleC}}</span><v-spacer v-if="collapsableC"/>
      <!--<action-button v-if="collapsableC" :tooltip="collapsed ? 'Expand': 'Collapse'" :icon="collapsed ? '$downList': '$upList'" @click="toggle"/>
      -->
      <v-icon v-if="collapsableC">{{ collapsed ? '$downList': '$upList' }}</v-icon>
      </v-card-title>
      <v-card-text v-if="!collapsableC || !collapsed">
      <slot />
      </v-card-text>
    </v-card>
</template>
<script>
export default {
    data() {
        return {
            collapsed: this.value,
            types: {
                'required': {icon: '$required', color: 'error', title: 'form.required'},
                'optional': {icon: '$optional', color: 'info', title: 'form.optional'},
                'basic': {icon: '$basic', color: 'success', title: 'form.basic'},
                'advanced': {icon: '$advanced', color: 'warning', title: 'form.advanced', collapsable: true }
            }
        }
    },
    props: { type: { type: String, default: 'required' }, icon: String, title: String, color: String, collapsable: {type: Boolean, default:  null }, value: { type: Boolean, default: true } },
    watch: {
        value(val) {
            this.collapsed = val;
        }
    },
    computed: {
        colorC() {
            return this.color || this.types[this.type].color;
        },
        iconC() {
            return this.icon || this.types[this.type].icon;
        },
        titleC() {
            return this.title || this.$t(this.types[this.type].title);
        },
        collapsableC() {
            return this.collapsable == null ? !!this.types[this.type].collapsable : this.collapsable;
        }
    },
    methods: {
        toggle() {
            this.collapsed = !this.collapsed; this.$emit('input', this.collapsed);
        }
    }
}
</script>